// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","main":"App_main__uN9ca"};